<template>
  <div class="container">
    <div class="container-tasks">
      <div class="mensaje">
        <label>Motivo</label>
        <textarea
          type="text"
          v-model="this.description"
          aria-multiline="true"
        />
      </div>
      <!-- DIV PARA CARGAR UN DOCUMENTO EN UNA COMUNICACION -->
      <div class="botonesCargaEnvio">
        <!-- INPUT PARA CARGAR ARCHIVO -->
        <div class="container-input">
          <input
            type="file"
            id="inputfile"
            :disabled="this.files.length >= 4"
            accept=".jpg, .jpeg, .png, .pdf, .docx, .xlsx"
            @change="selectFile"
            class="inputfile"
          />
          <label for="inputfile" class="iborrainputfile">
            <p style="margin-top: 3px; color: var(--bg-popup)">
              Adjuntar archivo
            </p>
          </label>
        </div>
        <!-- BOTON PARA ENVIAR LOS DATOS -->
        <div
          style="
            display: felx !important;
            flex-direction: column !important;
            gap: 8px !important;
            width: 50%;
          "
        >
          <input
            type="button"
            value="Enviar"
            @click="submitRequer"
            class="botonSubmit"
          />
        </div>
      </div>

      <p v-if="message" class="enviado">{{ this.message }}</p>

      <div class="mensaje">
        <label
          v-for="(file, index) in this.files"
          :key="index"
          class="iborrainputfile"
        >
          <p style="margin-top: 3px; color: var(--negro, #bbb)">
            {{ file.name }}
          </p>
        </label>
      </div>
    </div>
    <!-- Modal de éxito -->
    <div class="modal-overlay" v-if="modalSuccess">
      <div class="modal-exito">
        <div class="modal-constancia-top">
          <ThemedIcon
            name="close"
            class="imageConstancia"
            style="cursor: pointer; margin-left: 28rem"
            @click="closeModalSuccess"
          />
        </div>
        <div class="modalReq">
          <h2>¡Observación hecha con exito!</h2>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ThemedIcon from "@/components/Utils/ThemedIcon.vue";
import FileService from "@/services/infractions/filesService";
import FilesService from "@/services/office/filesService";

export default {
  name: "ObservationModalComponent",
  props: {
    submitFunction: Function,
    closeFunction: Function,
    succes: Boolean,
    inserted: Object,
    infra: Object,
  },

  data() {
    return {
      files: [],
      description: "",
      title: "",
      fileSelect: "",
      file: null,
      textInput: "",
      fileName: "",
      asd: false,
      message: null,
      modalSuccess: false,
    };
  },

  created() {},
  methods: {
    limpiarMensaje() {
      this.message = "";
    },
    selectFile(event) {
      const file = event.target.files[0];
      if (file) {
        this.files.push(file);
        this.file = file;
        this.fileName = file.name;
      }
    },
    // Subir el archivo al servidor (Reutilizable)
    async postFile(procedureId, groupCode) {
      if (!procedureId) {
        // console.error("El estadoId no está definido");
        this.message = "Por favor vuelva a Intentarlo mas tarde";
        return;
      }

      if (!this.file) {
        // console.error("No se ha seleccionado ningún archivo");
        this.message = "Debe seleccionar un archivo.";
        return;
      }

      this.files.forEach(async (file) => {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("id", procedureId);
        formData.append("action", "stateTransition");

        // Revisión del contenido de formData
        //for (let [key, value] of formData.entries()) {
        //    console.log(`FormData: ${key} =>`, value);
        //}

        try {
          const response = await FilesService.saveFile(formData);
          if (response.success) {
            FileService.saveFileUrl(response.data.url, groupCode);
            this.fileUploaded = true;
            this.message = "Archivo subido exitosamente.";
          }
        } catch (error) {
          this.message = "Error al subir el archivo. Inténtelo de nuevo.";
        }
      });
    },
    async submitRequer() {
      try {
        // Ejecutar la función de enviar los datos para la observacion
        await this.submitFunction(this.description);
        const id = this.inserted.id;
        const groupCode = this.inserted.uuid;

        if (this.succes) {
          if (this.inserted.document) {
            const constancia = await this.inserted.document();
            this.files.push(constancia);
            this.file = constancia;
          }
          // Subir los archivos al servidor
          if (this.file) {
            await this.postFile(id, groupCode);
          }

          this.showModalSuccess();
          await new Promise((resolve) => setTimeout(resolve, 4000));
          this.closeModalSuccess();
        } else {
          this.message = "Por favor vuelva a Intentarlo mas tarde";
        }
      } catch (error) {
        this.message = "Error al subir la observación. Inténtelo de nuevo.";
      }
    },
    showModalSuccess() {
      this.modalSuccess = true;
    },
    closeModalSuccess() {
      this.modalSuccess = false;
      this.closeFunction("closeFinalizedModal");
    },
  },
  components: {
    ThemedIcon,
  },
};
</script>
<style scoped>
.container {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
}

.container h3 {
  margin-left: 2rem;
  margin-top: 1rem;
  text-align: left;
}

.container-tasks {
  display: flex;
  width: 420px;
  gap: 24px;
  flex-direction: column;
  justify-content: center;
  border-top-width: 1px;
  text-align: left;
}

textarea {
  height: 10rem;
  padding-left: 1rem;
  height: 220px;
  border-radius: 12px;
  align-items: center;
  background: var(--Gris-claro, #f5f5f5);
  border: none;
  font-family: Montserrat;
}

.asunto {
  font-family: Montserrat;
}

.asunto input {
  display: flex;
  height: 40px;
  align-items: center;
  width: 100%;
  padding-left: 1rem;
  gap: 24px;
  align-self: stretch;
  border-radius: 12px;
  background: var(--Gris-claro, #f5f5f5);
  border: none;
  font-family: Montserrat;
}

input[type="submit"] {
  width: 8rem;
  margin: auto;
  border-radius: 10px;
  margin-top: 2rem;
}

.mensaje {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: Montserrat;
}

.botonesCargaEnvio {
  display: flex;
  align-items: center;
  gap: 14px;
}

.container-input {
  text-align: center;
  align-items: center;
  background: var(--color-yellow-muni);
  padding: 4px 16px;
  border-radius: 4px;
  height: 24px;
  width: 50%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.inputfile {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  cursor: pointer;
  width: 200px;
}

.inputfile + label {
  max-width: 80%;

  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
}

.inputfile + label svg {
  vertical-align: middle;
  fill: currentColor;
  margin-right: 5px;
}

.iborrainputfile {
  font-size: 11.2px;
  height: 24px;
  font-weight: 700;
  line-height: 16px;
  /* 142.857% */
  font-family: Montserrat;
  color: var(--bg-popup);
}

.botonSubmit {
  display: flex;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  width: 100%;
  height: 24px;
  background: var(--color-success);
  font-size: 11.2px;
  font-weight: 700;
  color: var(--bg-popup);
  border-style: none;
  font-family: Montserrat;
}

.enviado {
  color: var(--text-primary);
  font-family: Montserrat;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  margin-top: 5px;
  margin-bottom: -15px;
  line-height: 24px;
  /* 171.429% */
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-exito {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  position: fixed;
  margin-left: 2.5%;
  /*left: 53.5%;
    top: 50%;
    transform: translate(-50%, -50%);*/
  width: 502px;
  height: 180px;
  padding: 43.477px 36.612px 36.612px 36.612px;
  background: var(--bg-popup);
  border-radius: 18.306px;
}

.modalReq {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: flex-start;
  flex-direction: column;
}

.modalReq h2 {
  color: var(--text-primary);
  font-family: Montserrat;
  font-size: 21.88px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.modalReq h6 {
  color: var(--text-primary);
  font-family: Montserrat;
  font-size: 17.5px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.modal-constancia-top {
  display: flex;
  width: 100%;
  height: 33.18px;
  flex-shrink: 0;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: -20%;
  flex-direction: row-reverse;
}

.imageConstancia {
  margin-top: 13%;
}

.fileMensaje {
  margin-top: 20px;
}

.file-container {
  display: flex;
  width: 120%;
}

.file-intro {
  display: flex;
  justify-content: center;
  width: 100%;
}

.file-intro input[type="file"] {
  margin: auto;
}

.imgFile {
  height: 4rem;
  width: 4rem;
  margin: auto;
}

.buttonArchivo {
  color: var(--text-muted);
  font-family: Montserrat;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 38px;
}

input {
  display: flex;
  height: 48.576px;
  /*padding-right: 30px;*/
  align-items: center;
  /*flex-shrink: 0;*/
}

.fileup {
  margin: auto;
}

.cargado {
  text-align: center;
}

@media (max-width: 768px) {
  .container-tasks {
    width: 120%;
  }

  .modal-exito {
    width: 90%;
    margin-left: 0%;
  }
}
</style>
